import { Link, useParams } from "react-router-dom";

const PREVIEW_BASE: string =
  (import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_PREVIEW_BASE ??
  "http://localhost:5173";

export function Preview() {
  const { slug = "" } = useParams();
  const src = buildPreviewUrl(slug);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Link
          to={`/quizzes/${slug}`}
          className="mono text-[0.7rem] uppercase tracking-[0.16em] text-mars-white/50 hover:text-mars-white"
        >
          &larr; Back to {slug}
        </Link>
        <a
          href={src}
          target="_blank"
          rel="noreferrer"
          className="mono text-[0.7rem] uppercase tracking-[0.16em] text-mars-orange hover:text-mars-orange-deep"
        >
          Open in new tab
        </a>
      </div>
      <iframe
        title={`Preview ${slug}`}
        src={src}
        className="h-[80vh] w-full rounded-2xl border border-mars-line bg-mars-black"
      />
      <p className="mono text-[0.65rem] uppercase tracking-[0.14em] text-mars-white/40">
        Preview mode — submissions and analytics disabled. Set{" "}
        <code className="rounded bg-mars-charcoal px-1 py-0.5">VITE_PREVIEW_BASE</code> to point at
        a different widget URL.
      </p>
    </div>
  );
}

function buildPreviewUrl(slug: string): string {
  const url = new URL(PREVIEW_BASE, window.location.origin);
  url.searchParams.set("quiz", slug);
  url.searchParams.set("preview", "1");
  return url.toString();
}
